import {
  Paper,
  Icon,
  Icons,
  TypographyElement,
  Skeleton
} from 'UI'
import Text from './text.json'
import { createUseStyles } from 'react-jss'
import styles from './style'
import { formatSecondsDuration } from 'helpers'

const useStyle = createUseStyles(styles)

export default ({ Duration = 0, ViewersCount = 0, margin, loading, IsFree }) => {
  const { paperClass, iconClass, infoGroup, firstCol, secondCol, itemsClass } = useStyle({ margin })
  return (
    <Paper noHover={loading} className={paperClass}>
      {
        loading
          ? <Skeleton lines={1} width='60%' height={25} margin='0 0 13px 0' />
          : (
            <TypographyElement
              component='h3'
              variant='heading5'
              spacing='0 0 13px 0'
            >
              {IsFree ? Text.freeTitle : Text.title}
            </TypographyElement>
            )
      }
      <div className={infoGroup}>
        <div className={firstCol}>
          {
            loading
              ? <Skeleton wrapperWidth='200px' lines={3} width={['80%', '70%', '60%']} height={30} gap={16} />
              : (
                <>
                  <TypographyElement
                    variant='body1'
                    display='inline-flex'
                    className={itemsClass}
                    spacing='0 0 10px 0'
                  >
                    <Icon iconName={Icons.offline} style={iconClass} />{Text.offline}
                  </TypographyElement>
                  <TypographyElement
                    variant='body1'
                    display='inline-flex'
                    className={itemsClass}
                    spacing='0 0 10px 0'
                  >
                    <Icon iconName={Icons.comments} style={iconClass} />{Text.collaboratifSpace}
                  </TypographyElement>
                  <TypographyElement
                    variant='body1'
                    display='inline-flex'
                    className={itemsClass}
                  >
                    <Icon iconName={Icons.lock} style={iconClass} />{Text.access}
                  </TypographyElement>
                </>
                )
          }
        </div>
        <div className={secondCol}>
          {
            loading
              ? <Skeleton wrapperWidth='200px' lines={3} width={['20%', '40%', '50%']} height={30} gap={16} />
              : (
                <>
                  <TypographyElement
                    variant='body1'
                    display='inline-flex'
                    className={itemsClass}
                    spacing='0 0 10px 0'
                  >
                    <Icon iconName={Icons.user} style={iconClass} />{ViewersCount}
                  </TypographyElement>
                  <TypographyElement
                    variant='body1'
                    display='inline-flex'
                    className={itemsClass}
                    spacing='0 0 10px 0'
                  >
                    <Icon iconName={Icons.smartPhone} style={iconClass} />{Text.appMobile}
                  </TypographyElement>
                  <TypographyElement
                    variant='body1'
                    display='inline-flex'
                    className={itemsClass}
                  >
                    <Icon iconName={Icons.clock} style={iconClass} />{formatSecondsDuration(Duration)}
                  </TypographyElement>
                </>
                )
          }
        </div>
      </div>
    </Paper>
  )
}
